export const routeUrls = {
    home: '/language',
    welcome: '/welcome/:lang',
    streaming: '/streaming/:lang'
};
